import ContentTypeAutoImportConfigField from '@/ecm/models/contentType/autoImport/ContentTypeAutoImportConfigField';
import Utils from '@/ecm/common/Utils';
export default class ContentTypeAutoImportConfig {
    constructor(dto) {
        this.id = 0;
        this.uuid = Utils.object.getUUID();
        this.contentTypeID = 0;
        this.description = '';
        this.emailAccount = '';
        this.emailPassword = '';
        this.emailPort = '';
        this.emailServer = '';
        this.emailUseSSL = 'false';
        this.serviceID = 1;
        this.oAuthRefreshToken = '';
        this.rootFolder = '';
        this.nameFolder = '';
        this.oAuthAccessToken = '';
        this.folderList = [];
        this.fields = [];
        this.convertImageToPdf = false;
        this.convertOfficeToPdf = false;
        this.hasImputationPlugin = false;
        this.importingImputationRows = false;
        this.isNew = false;
        this.oneDriveSubscriptionId = '';
        this.oneDriveSubscriptionExpirationDate = '';
        this.alphaNumericSeparator = '';
        this.loading = false;

        if (dto) {
            Object.assign(this, dto, {
                fields: dto.fields.map((field) => new ContentTypeAutoImportConfigField(field)),
            });
        }
    }

    toDto() {
        return {
            Id: this.id,
            ContentTypeId: this.contentTypeID,
            Description: this.description,
            EmailAccount: this.emailAccount,
            EmailPassword: this.emailPassword,
            EmailPort: this.emailPort,
            EmailServer: this.emailServer,
            EmailUseSSL: this.emailUseSSL.toString(),
            ServiceId: this.serviceID,
            OAuthRefreshToken: this.oAuthRefreshToken,
            RootFolder: this.rootFolder,
            ConvertImageToPdf: this.convertImageToPdf,
            ConvertOfficeToPdf: this.convertOfficeToPdf,
            HasImputationPlugin: this.hasImputationPlugin,
            ImportingImputationRows: this.importingImputationRows,
            Fields: this.fields.map((field) => field.toDto()),
            OneDriveSubscriptionExpirationDate: this.oneDriveSubscriptionExpirationDate,
            OneDriveSubscriptionId: this.oneDriveSubscriptionId,
            AlphaNumericSeparator: this.alphaNumericSeparator || ''
        };
    }
}
